import api from './api';

export const couponsAPI = {
  generateMultiple: (feeType, discountPct, count) => api.post('/coupons/generate-multiple', {
    feeType,
    discountPct,
    count: Number(count)
  }),
  getAllCoupons: () => api.get('/coupons/get-coupons'),
  getUnUsedCoupons: () => api.get('/coupons/get-unused-coupons'),
  getAssignCoupons: (couponId) => api.get(`/coupons/get-assign-coupon-code/${couponId}`),

  verifyCoupon: (couponId) => api.get(`/coupons/verify-coupon/${couponId}`),
};